/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';



import { Observable } from 'rxjs';
import { AccessTokenError } from '../model/accessTokenError';
import { ErrorMessage } from '../model/errorMessage';
import { InlineResponse2006 } from '../model/inlineResponse2006';
import { InlineResponse2007 } from '../model/inlineResponse2007';
import { Request5 } from '../model/request5';
import { Request6 } from '../model/request6';
import { SiteDefinitionRetrieveResponseInfo } from '../model/siteDefinitionRetrieveResponseInfo';
import { SiteResourceCreateResponseInfo } from '../model/siteResourceCreateResponseInfo';
import { SiteResourceCreateResponseInfoList } from '../model/siteResourceCreateResponseInfoList';
import { SiteResourceLinkRequestInfo } from '../model/siteResourceLinkRequestInfo';
import { SiteResourceLinkResponseInfo } from '../model/siteResourceLinkResponseInfo';
import { SiteSettingRetrieveAllResponseInfo } from '../model/siteSettingRetrieveAllResponseInfo';
import { SiteSettingSummaryRequestInfo } from '../model/siteSettingSummaryRequestInfo';
import { SiteSettingSummaryResponseInfo } from '../model/siteSettingSummaryResponseInfo';
import { SiteSettingValueCreateRequestInfo } from '../model/siteSettingValueCreateRequestInfo';
import { SiteSettingValueCreateResponseInfo } from '../model/siteSettingValueCreateResponseInfo';
import { SiteSettingValueHistoryRetrieveRequestInfo } from '../model/siteSettingValueHistoryRetrieveRequestInfo';
import { SiteSettingValueHistoryRetrieveResponseInfo } from '../model/siteSettingValueHistoryRetrieveResponseInfo';
import { SiteSettingValueRequestInfo } from '../model/siteSettingValueRequestInfo';
import { SiteSettingValueResponseInfo } from '../model/siteSettingValueResponseInfo';
import { SiteSettingValueRetrieveAllRequestInfo } from '../model/siteSettingValueRetrieveAllRequestInfo';
import { SiteSettingValueRetrieveAllResponseInfo } from '../model/siteSettingValueRetrieveAllResponseInfo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SiteMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * SiteMgr_SassToCSS, Convert from Sass to CSS
     * Convert from Sass to CSS
     * @param File Upload the Sass file here
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SassToCSSPost(File: Blob, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public orgMgrSiteMgrV1SassToCSSPost(File: Blob, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public orgMgrSiteMgrV1SassToCSSPost(File: Blob, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public orgMgrSiteMgrV1SassToCSSPost(File: Blob, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (File === null || File === undefined) {
            throw new Error('Required parameter File was null or undefined when calling orgMgrSiteMgrV1SassToCSSPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/css'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (File !== undefined) {
            formParams = formParams.append('File', <any>File) || formParams;
        }

        return this.httpClient.post(`${this.basePath}/OrgMgr/SiteMgr/V1/SassToCSS`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RetrieveSiteDefinition, Retrieve the SiteDefinition
     * Retrieve the SiteDefinition by AppId
     * @param AppName Enter the AppName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteDefinitionGet(AppName: string, observe?: 'body', reportProgress?: boolean): Observable<SiteDefinitionRetrieveResponseInfo>;
    public orgMgrSiteMgrV1SiteDefinitionGet(AppName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteDefinitionRetrieveResponseInfo>>;
    public orgMgrSiteMgrV1SiteDefinitionGet(AppName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteDefinitionRetrieveResponseInfo>>;
    public orgMgrSiteMgrV1SiteDefinitionGet(AppName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrSiteMgrV1SiteDefinitionGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (AppName !== undefined) {
            queryParameters = queryParameters.set('AppName', <any>AppName);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SiteDefinitionRetrieveResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteDefinition`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_DeleteSiteResource, Delete the SiteResource
     * Delete the SiteResource
     * @param Level Enter the Level, Allowed values are Org and Group
     * @param Name Enter the Name
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourceDelete(Level: string, Name: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrSiteMgrV1SiteResourceDelete(Level: string, Name: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrSiteMgrV1SiteResourceDelete(Level: string, Name: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrSiteMgrV1SiteResourceDelete(Level: string, Name: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrSiteMgrV1SiteResourceDelete.');
        }
        if (Name === null || Name === undefined) {
            throw new Error('Required parameter Name was null or undefined when calling orgMgrSiteMgrV1SiteResourceDelete.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }
        if (Name !== undefined) {
            queryParameters = queryParameters.set('Name', <any>Name);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_DownloadSiteResource, Download a SiteResource
     * Update a SiteResource
     * @param Level Enter the Level, Allowed values are Group and Org
     * @param Name Enter the Name
     * @param SiteName Enter the SiteName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet(Level: string, Name: string, SiteName: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet(Level: string, Name: string, SiteName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet(Level: string, Name: string, SiteName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet(Level: string, Name: string, SiteName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet.');
        }
        if (Name === null || Name === undefined) {
            throw new Error('Required parameter Name was null or undefined when calling orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet.');
        }
        if (SiteName === null || SiteName === undefined) {
            throw new Error('Required parameter SiteName was null or undefined when calling orgMgrSiteMgrV1SiteResourceDownloadLevelSiteNameNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/png',
            'text/css'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource/Download/${encodeURIComponent(String(Level))}/${encodeURIComponent(String(SiteName))}/${encodeURIComponent(String(Name))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RetrieveSiteResource, Retrieve the SiteResource by OrgId
     * Retrieve the SiteResource by OrgId
     * @param Level Enter the Level, Allowed values are System, Org and Group
     * @param OrgId Enter the OrgId
     * @param GroupId Enter the GroupId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourceGet(Level: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'body', reportProgress?: boolean): Observable<SiteResourceCreateResponseInfoList>;
    public orgMgrSiteMgrV1SiteResourceGet(Level: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteResourceCreateResponseInfoList>>;
    public orgMgrSiteMgrV1SiteResourceGet(Level: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteResourceCreateResponseInfoList>>;
    public orgMgrSiteMgrV1SiteResourceGet(Level: string, OrgId?: number, GroupId?: number, FacilityId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrSiteMgrV1SiteResourceGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Level !== undefined) {
            queryParameters = queryParameters.set('Level', <any>Level);
        }
        if (OrgId !== undefined) {
            queryParameters = queryParameters.set('OrgId', <any>OrgId);
        }
        if (GroupId !== undefined) {
            queryParameters = queryParameters.set('GroupId', <any>GroupId);
        }
        if (FacilityId !== undefined) {
            queryParameters = queryParameters.set('FacilityId', <any>FacilityId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SiteResourceCreateResponseInfoList>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_DownloadSiteResource, Download a SiteResource by Id
     * Update a SiteResource by Id
     * @param Id Enter the SiteResource Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourceIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public orgMgrSiteMgrV1SiteResourceIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public orgMgrSiteMgrV1SiteResourceIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public orgMgrSiteMgrV1SiteResourceIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrSiteMgrV1SiteResourceIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/png',
            'text/css'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource/${encodeURIComponent(String(Id))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_SiteResourceLink, Get SiteResource Link
     * Get SiteResource Link
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourceLinksPost(Request: SiteResourceLinkRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteResourceLinkResponseInfo>;
    public orgMgrSiteMgrV1SiteResourceLinksPost(Request: SiteResourceLinkRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteResourceLinkResponseInfo>>;
    public orgMgrSiteMgrV1SiteResourceLinksPost(Request: SiteResourceLinkRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteResourceLinkResponseInfo>>;
    public orgMgrSiteMgrV1SiteResourceLinksPost(Request: SiteResourceLinkRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteResourceLinksPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SiteResourceLinkResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource/Links`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_UploadSiteResource, Create a SiteResource
     * Create a SiteResource
     * @param Level Enter the Level, Allowed values are System, Org and Group
     * @param AppId Enter the AppId
     * @param ResourceType Enter the ResourceType, Allowed values are Video, Image and Css
     * @param ResourceName Enter the ResourceName
     * @param File Upload the file here, Max file size allowed is 25Mb
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteResourcePost(Level: string, AppId: number, ResourceType: string, ResourceName: string, File: Blob, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<SiteResourceCreateResponseInfo>;
    public orgMgrSiteMgrV1SiteResourcePost(Level: string, AppId: number, ResourceType: string, ResourceName: string, File: Blob, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteResourceCreateResponseInfo>>;
    public orgMgrSiteMgrV1SiteResourcePost(Level: string, AppId: number, ResourceType: string, ResourceName: string, File: Blob, OrgId?: number, FacilityId?: number, GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteResourceCreateResponseInfo>>;
    public orgMgrSiteMgrV1SiteResourcePost(Level: string, AppId: number, ResourceType: string, ResourceName: string, File: Blob, OrgId?: number, FacilityId?: number, GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Level === null || Level === undefined) {
            throw new Error('Required parameter Level was null or undefined when calling orgMgrSiteMgrV1SiteResourcePost.');
        }
        if (AppId === null || AppId === undefined) {
            throw new Error('Required parameter AppId was null or undefined when calling orgMgrSiteMgrV1SiteResourcePost.');
        }
        if (ResourceType === null || ResourceType === undefined) {
            throw new Error('Required parameter ResourceType was null or undefined when calling orgMgrSiteMgrV1SiteResourcePost.');
        }
        if (ResourceName === null || ResourceName === undefined) {
            throw new Error('Required parameter ResourceName was null or undefined when calling orgMgrSiteMgrV1SiteResourcePost.');
        }
        if (File === null || File === undefined) {
            throw new Error('Required parameter File was null or undefined when calling orgMgrSiteMgrV1SiteResourcePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        const convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (Level !== undefined) {
            formParams = formParams.append('Level', <any>Level) || formParams;
        }
        if (OrgId !== undefined) {
            formParams = formParams.append('OrgId', <any>OrgId) || formParams;
        }
        if (FacilityId !== undefined) {
            formParams = formParams.append('FacilityId', <any>FacilityId) || formParams;
        }
        if (GroupId !== undefined) {
            formParams = formParams.append('GroupId', <any>GroupId) || formParams;
        }
        if (AppId !== undefined) {
            formParams = formParams.append('AppId', <any>AppId) || formParams;
        }
        if (ResourceType !== undefined) {
            formParams = formParams.append('ResourceType', <any>ResourceType) || formParams;
        }
        if (ResourceName !== undefined) {
            formParams = formParams.append('ResourceName', <any>ResourceName) || formParams;
        }
        if (File !== undefined) {
            formParams = formParams.append('File', <any>File) || formParams;
        }

        return this.httpClient.post<SiteResourceCreateResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteResource`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RetrieveAllSiteSetting, RetrieveAll the SiteSetting
     * RetrieveAll the SiteSetting
     * @param AppId Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingRetrieveGet(AppId: number, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingRetrieveAllResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingRetrieveGet(AppId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingRetrieveAllResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingRetrieveGet(AppId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingRetrieveAllResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingRetrieveGet(AppId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (AppId === null || AppId === undefined) {
            throw new Error('Required parameter AppId was null or undefined when calling orgMgrSiteMgrV1SiteSettingRetrieveGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (AppId !== undefined) {
            queryParameters = queryParameters.set('AppId', <any>AppId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SiteSettingRetrieveAllResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSetting/Retrieve`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_SiteSettingSummary, Get SiteSetting Summary
     * Get SiteSetting Summary
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingSummaryPost(Request: SiteSettingSummaryRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingSummaryResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingSummaryPost(Request: SiteSettingSummaryRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingSummaryResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingSummaryPost(Request: SiteSettingSummaryRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingSummaryResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingSummaryPost(Request: SiteSettingSummaryRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingSummaryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SiteSettingSummaryResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSetting/Summary`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_SiteSettingValueHistoryDownload, Retrieve SiteSettingValue History Download by SiteSettingValueId
     * Retrieve SiteSettingValue History Download by SiteSettingValueId
     * @param SiteSettingValueId Enter SiteSettingValueId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueHistoryDownloadPost(SiteSettingValueId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryDownloadPost(SiteSettingValueId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryDownloadPost(SiteSettingValueId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryDownloadPost(SiteSettingValueId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (SiteSettingValueId === null || SiteSettingValueId === undefined) {
            throw new Error('Required parameter SiteSettingValueId was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueHistoryDownloadPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (SiteSettingValueId !== undefined) {
            queryParameters = queryParameters.set('SiteSettingValueId', <any>SiteSettingValueId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/csv'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<any>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValueHistory/Download`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RetrieveSiteSettingHistory, Retrieve SiteSettingValue History by SiteSettingId
     * Retrieve SiteSettingValue History by SiteSettingId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueHistoryPost(Request: SiteSettingValueHistoryRetrieveRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingValueHistoryRetrieveResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryPost(Request: SiteSettingValueHistoryRetrieveRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingValueHistoryRetrieveResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryPost(Request: SiteSettingValueHistoryRetrieveRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingValueHistoryRetrieveResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueHistoryPost(Request: SiteSettingValueHistoryRetrieveRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueHistoryPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SiteSettingValueHistoryRetrieveResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValueHistory`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_DeleteSiteSettingValue, Delete the SiteSettingValue
     * Delete the SiteSettingValue
     * @param Id Enter the Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrSiteMgrV1SiteSettingValueIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrSiteMgrV1SiteSettingValueIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrSiteMgrV1SiteSettingValueIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValue/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_UpdateSiteSettingValue, Update a SiteSettingValue
     * Update a SiteSettingValue
     * @param Id Enter the Id
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueIdPut(Id: number, Request: SiteSettingValueRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingValueResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingValueIdPut(Id: number, Request: SiteSettingValueRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingValueResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueIdPut(Id: number, Request: SiteSettingValueRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingValueResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueIdPut(Id: number, Request: SiteSettingValueRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<SiteSettingValueResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValue/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_CreateSiteSettingValue, Create a SiteSettingValue
     * Create a SiteSettingValue
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValuePost(Request: SiteSettingValueCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingValueCreateResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingValuePost(Request: SiteSettingValueCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingValueCreateResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValuePost(Request: SiteSettingValueCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingValueCreateResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValuePost(Request: SiteSettingValueCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingValuePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SiteSettingValueCreateResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValue`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RetrieveSiteSettingValue, Retrieve all SiteSettingValue by name
     * Retrieve all SiteSettingValue by SiteSettingName or Id
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueRetrievePost(Request: SiteSettingValueRetrieveAllRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<SiteSettingValueRetrieveAllResponseInfo>;
    public orgMgrSiteMgrV1SiteSettingValueRetrievePost(Request: SiteSettingValueRetrieveAllRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SiteSettingValueRetrieveAllResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueRetrievePost(Request: SiteSettingValueRetrieveAllRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SiteSettingValueRetrieveAllResponseInfo>>;
    public orgMgrSiteMgrV1SiteSettingValueRetrievePost(Request: SiteSettingValueRetrieveAllRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueRetrievePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<SiteSettingValueRetrieveAllResponseInfo>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValue/Retrieve`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_RuleExecute, Execute the rule
     * Execute the rule
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1SiteSettingValueRulesEngineExecutePost(Request: Request5, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2006>;
    public orgMgrSiteMgrV1SiteSettingValueRulesEngineExecutePost(Request: Request5, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2006>>;
    public orgMgrSiteMgrV1SiteSettingValueRulesEngineExecutePost(Request: Request5, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2006>>;
    public orgMgrSiteMgrV1SiteSettingValueRulesEngineExecutePost(Request: Request5, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1SiteSettingValueRulesEngineExecutePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<InlineResponse2006>(`${this.basePath}/OrgMgr/SiteMgr/V1/SiteSettingValue/RulesEngine/Execute`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * SiteMgr_Translate, Translate the given text
     * Translate the given text from Source Language to Target Language
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrSiteMgrV1TranslatePost(Request: Request6, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2007>;
    public orgMgrSiteMgrV1TranslatePost(Request: Request6, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2007>>;
    public orgMgrSiteMgrV1TranslatePost(Request: Request6, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2007>>;
    public orgMgrSiteMgrV1TranslatePost(Request: Request6, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrSiteMgrV1TranslatePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<InlineResponse2007>(`${this.basePath}/OrgMgr/SiteMgr/V1/Translate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
